
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-design/webdienste",
      function () {
        return require("private-next-pages/corporate-design/webdienste.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-design/webdienste"])
      });
    }
  